import React from "react";
import { Button, Space, Select, InputNumber } from "antd";
import {
  PlusOutlined,
  DownloadOutlined,
  ReloadOutlined,
} from "@ant-design/icons";
function RewardsToolbar({
  data,
  busy,
  saving,
  campaign,
  user,
  setCampaign,
  setUser,
  setPage,
  edit,
  load,
  exportRows,
  setShowGuide,
}) {
  return (
    <Space wrap style={{ width: "100%", justifyContent: "flex-end" }}>
      <Button onClick={() => setShowGuide(true)}>User guide</Button>
      <Button icon={<ReloadOutlined />} loading={busy} onClick={load}>
        Refresh
      </Button>
      <Button
        type="primary"
        icon={<PlusOutlined />}
        disabled={!data}
        onClick={() => edit()}
      >
        New campaign
      </Button>
      <Select
        allowClear
        placeholder="All campaigns"
        style={{
          width: 240,
        }}
        value={campaign}
        onChange={(x) => {
          setCampaign(x);
          setPage(0);
        }}
        options={data?.campaigns.map((c) => ({
          value: c.id,
          label: `${c.name} (#${c.id})`,
        }))}
      />
      <InputNumber
        placeholder="Student ID"
        min={1}
        value={user}
        onChange={(x) => {
          setUser(x);
          setPage(0);
        }}
      />
      <Button
        icon={<DownloadOutlined />}
        disabled={!data}
        loading={saving}
        onClick={exportRows}
      >
        Export awards CSV
      </Button>
    </Space>
  );
}
export default RewardsToolbar;
